var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{staticClass:"cls-tabs-content",attrs:{"type":"card"},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"联行号基础库","name":"cnaps"}},[_c('Cnaps')],1),_c('el-tab-pane',{attrs:{"label":"银盛银行代码","name":"ysfbank"}},[_c('YsfBank')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }